module.exports = __webpack_public_path__ + "img/header-2.2ff9ebad.svg";